import React from 'react';
import MobileMenu from './MobileMenu';
import NoraMenuItems from './NoraMenuItems';
import Box from '@mui/material/Box';

export default function NoraMenu() {
  const drawerWidth = 0;

  return (
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { md: 0 } }}
      aria-label="mailbox folders"
    >
      <MobileMenu pages={NoraMenuItems}/>
    </Box>
  )

  }
